/**
 * Dynamically imports the header styles.
 *
 * @returns A promise that resolves when the styles are successfully loaded.
 */
const loadHeaderStyles = async (): Promise<void> => {
  await import(
    '../../styles/01-components/01-header/lazy/desktop/menu-dropdown.css'
  );
};

/**
 * Initializes the header by dynamically importing the necessary module.
 * If the header element is not found on the page, the function will exit early.
 *
 * @throws Will throw an error if the fixed header initialization fails.
 */
export const initializeHeader = async (): Promise<void> => {
  const headerElement = document.querySelector<HTMLDivElement>('#header');

  if (!headerElement) return; // Exit if the header element is not found

  const menuDropdownElement =
    document.querySelector<HTMLDivElement>('.dmm-dropdown');

  try {
    await loadHeaderStyles();

    if (menuDropdownElement) {
      const { mainDesktopMenuDropdown } = await import(
        '../components/header/main-desktop-menu-dropdown'
      );

      mainDesktopMenuDropdown.init();
    }
  } catch (error: unknown) {
    // eslint-disable-next-line no-console
    console.error('🚨 Error initializing header:', error);

    throw new Error(
      `Failed to initialize header: ${error instanceof Error ? error.message : String(error)}`,
    );
  }
};
